import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    assignedConnectionPointsRx: []
}

export const groupSlice = createSlice({
    name: 'groups',
    initialState,
    reducers: {
        addAssignedConnectionPoints: (state, action) => {
            const filter = action.payload
            for (const id of filter) {
                if (!state.assignedConnectionPointsRx.includes(id)) {
                    state.assignedConnectionPointsRx.push(id)
                }
            }
        },
        addSingleAssignedConnectionPoint: (state, action) => {
            state.assignedConnectionPointsRx.push(action.payload)
        },
        removeAssignedConnectionPoints: (state, action) => {
            const filter = action.payload
            state.assignedConnectionPointsRx = state.assignedConnectionPointsRx.filter((el) => {
                return !filter.includes(el)
            })
        },
        removeSingleConnectionPoint: (state, action) => {
            state.assignedConnectionPointsRx.splice(action.payload, 1)
        }
    }
})

export const {
    addAssignedConnectionPoints,
    removeAssignedConnectionPoints,
    addSingleAssignedConnectionPoint,
    removeSingleConnectionPoint
} = groupSlice.actions
export default groupSlice.reducer
